import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'base-modal',
    template: ``,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export abstract class BaseModalComponent  {
  @Input() isOpen: boolean;
  @Output() onModalClosed = new EventEmitter<void>();

  close() {
    this.isOpen = false;
    this.onModalClosed.emit();
  }
}
